import * as Actions from './types';
import { GET_CARD_SUCCESS } from '../billing/types';
import {
  getSubscriptionApi,
  getSubscriptionPlansApi,
  updateSubscriptionApi,
  getAddOnsListApi,
  subscribeAddOnsApi,
  retryPaymentApi,
  unsubscribePlanApi,
  endTrialApi,
  payInvoiceApi,
  upgradePlanApi,
} from '../../api/subscription/subscription-api';

// get subscribed plan details
export const getSubscription = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_SUBSCRIPTION_REQUEST,
    });
    const { data } = await getSubscriptionApi();
    dispatch({
      type: Actions.GET_SUBSCRIPTION_SUCCESS,
      payload: data || '',
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_SUBSCRIPTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// get subscription plans list for onboarding dropdown
export const getSubscriptionPlans = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_SUBSCRIPTION_PLANS_REQUEST,
    });
    const { data } = await getSubscriptionPlansApi();
    dispatch({
      type: Actions.GET_SUBSCRIPTION_PLANS_SUCCESS,
      payload: data || [],
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_SUBSCRIPTION_PLANS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// get add ons List
export const getAddOnsList = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_ADD_ONS_LIST_REQUEST,
    });
    const { data } = await getAddOnsListApi();
    dispatch({
      type: Actions.GET_ADD_ONS_LIST_SUCCESS,
      payload: data || [],
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_ADD_ONS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// subscribe add ons
export const subscribeAddOns = (list) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SUBSCRIBE_ADD_ONS_REQUEST,
    });
    const { data } = await subscribeAddOnsApi(list);
    dispatch({
      type: Actions.SUBSCRIBE_ADD_ONS_SUCCESS,
      payload: data || [],
    });
  } catch (error) {
    dispatch({
      type: Actions.SUBSCRIBE_ADD_ONS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// update subscription
export const updateSubscription = (planData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_SUBSCRIPTION_REQUEST,
    });
    const { data } = await updateSubscriptionApi(planData);
    dispatch({
      type: Actions.UPDATE_SUBSCRIPTION_SUCCESS,
      payload: data || '',
    });

    dispatch({
      type: GET_CARD_SUCCESS,
      payload: data.card || '',
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_SUBSCRIPTION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// retry payment
export const retryPayment = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.RETRY_PAYMENT_REQUEST,
    });
    const { data } = await retryPaymentApi();
    dispatch({
      type: Actions.RETRY_PAYMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.RETRY_PAYMENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// unsubscribe plan
export const unsubscribePlan = (_data) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UNSUBSCRIBE_PLAN_REQUEST,
    });
    const { data } = await unsubscribePlanApi(_data);
    dispatch({
      type: Actions.UNSUBSCRIBE_PLAN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UNSUBSCRIBE_PLAN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// end trial
export const endTrial = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.END_TRIAL_REQUEST,
    });
    const { data } = await endTrialApi();
    dispatch({
      type: Actions.END_TRIAL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.END_TRIAL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// pay invoice
export const payInvoice = (_data) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.PAY_INVOICE_REQUEST,
    });
    const { data } = await payInvoiceApi(_data);
    dispatch({
      type: Actions.PAY_INVOICE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.PAY_INVOICE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// upgrade plan
export const upgradePlan = (_data) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPGRADE_PLAN_REQUEST,
    });
    const { data } = await upgradePlanApi(_data);
    dispatch({
      type: Actions.UPGRADE_PLAN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPGRADE_PLAN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
